export default (that) => [
  {
    text: that.$l('tips_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('tips_text_edit') || '编辑信息',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    data: {},
    disabled: ({ status }) => status != 'A',
  },
  {
    text: that.$l('tips_text_delete') || '删除信息',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: false,
    allow: 'D',
    data: {},
    disabled: ({ status }) => status === 'D',
  },
  {
    text: that.$l('tips_text_audit') || '设备报废',
    icon: 'el-icon-back',
    menuType: 'scrap',
    divided: true,
    allow: 'B',
    data: {},
    disabled: ({ status }) => status != 'A',
  },
]
